import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  trendingMovies: boolean;
  adventureMovies: boolean;
  comedyMovies: boolean;
  thrillerMovies: boolean;
  scificMovies: boolean;
  animationMovies: boolean;
  documentaryMovies: boolean;
  mysteryMovies: boolean;
  westernMovies: boolean;
};

const initialState: InitialState = {
  trendingMovies: true,
  adventureMovies: true,
  comedyMovies: true,
  thrillerMovies: true,
  scificMovies: true,
  animationMovies: true,
  documentaryMovies: true,
  mysteryMovies: true,
  westernMovies: true,
};

const mediaTypeSlice = createSlice({
  name: "mediaTypeSlice",
  initialState,
  reducers: {
    setTrendingMovies: (state, action: PayloadAction<boolean>) => {
      state.trendingMovies = action.payload;
      return state;
    },
    setAdventureMovies: (state, action: PayloadAction<boolean>) => {
      state.adventureMovies = action.payload;
      return state;
    },
    setComedyMovies: (state, action: PayloadAction<boolean>) => {
      state.comedyMovies = action.payload;
      return state;
    },
    setThrillerMovies: (state, action: PayloadAction<boolean>) => {
      state.thrillerMovies = action.payload;
      return state;
    },
    setScificMovies: (state, action: PayloadAction<boolean>) => {
      state.scificMovies = action.payload;
      return state;
    },
    setAnimationMovies: (state, action: PayloadAction<boolean>) => {
      state.animationMovies = action.payload;
      return state;
    },
    setDocumentaryMovies: (state, action: PayloadAction<boolean>) => {
      state.documentaryMovies = action.payload;
      return state;
    },
    setMysteryMovies: (state, action: PayloadAction<boolean>) => {
      state.mysteryMovies = action.payload;
      return state;
    },
    setWesternMovies: (state, action: PayloadAction<boolean>) => {
      state.westernMovies = action.payload;
      return state;
    },
    resetMediaToMovies: (state, action: PayloadAction) => {
      state.trendingMovies = true;
      state.adventureMovies = true;
      state.comedyMovies = true;
      state.thrillerMovies = true;
      state.scificMovies = true;
      state.animationMovies = true;
      state.documentaryMovies = true;
      state.mysteryMovies = true;
      state.westernMovies = true;
      return state;
    },
    resetMediaToSeries: (state, action: PayloadAction) => {
      state.trendingMovies = false;
      state.adventureMovies = false;
      state.comedyMovies = false;
      state.thrillerMovies = false;
      state.scificMovies = false;
      state.animationMovies = false;
      state.documentaryMovies = false;
      state.mysteryMovies = false;
      state.westernMovies = false;
      return state;
    },
  },
});

export const {
  setTrendingMovies,
  setAdventureMovies,
  setComedyMovies,
  setThrillerMovies,
  setScificMovies,
  setAnimationMovies,
  setWesternMovies,
  setDocumentaryMovies,
  setMysteryMovies,
  resetMediaToMovies,
  resetMediaToSeries
} = mediaTypeSlice.actions;
export default mediaTypeSlice;
